import { API } from "@js/api";

import type { IdentityVerificationInquiry } from "./types";

const identityVerificationApi = API.injectEndpoints({
  endpoints: (build) => ({
    getIdentityVerificationInquiry: build.query<
      IdentityVerificationInquiry,
      void
    >({
      query: () => ({
        url: "/persona/get_or_create_inquiry",
        method: "POST",
      }),
      keepUnusedDataFor: 1,
      providesTags: ["IdentityVerifications"],
    }),
  }),
});

export const { useGetIdentityVerificationInquiryQuery } =
  identityVerificationApi;
